import { Menu } from "lucide-react";

export default function Header({ onOpenSidebar }) {
  return (
    <header className="flex items-center gap-4 bg-secondary-950 p-3 md:hidden z-10">
      <button onClick={onOpenSidebar} aria-label="Öffne Menü" className="p-2">
        <Menu size={22} />
      </button>
      <div className="flex items-center gap-3">
        <img
          src="/logo192.png"  
          alt="Kirtagames Logo"
          className="w-10 h-10 rounded-xl object-contain"
        />
        <h1 className="text-lg font-bold">Kirtagames</h1>
      </div>
    </header>
  );
}
